/*
 * @Author: bianbinbin
 * @Date: 2026-01-14 19:15:53
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-03-18 16:16:07
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/electronicTaskBook.js
 */
const electronicTaskBook = r => require.ensure([], () => r(require('@/views/electronicTaskBook/electronicTaskBook.vue'), 'electronicTaskBook'))
const router = [
  {
    path: '/electronicTaskBook',
    name: 'electronicTaskBook',
    meta: {
      title: '电子任务书'
    },
    component: electronicTaskBook
  },
]

export default router
